import React from "react";
import { Typography, useTheme } from "@mui/material";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { PaginatorProps } from "./types";
import { PaginatorContainer, NavBtn } from "./style";

const PaginatorCst: React.FC<PaginatorProps> = ({
  page,
  pageSize,
  totalItems,
  onPageChange,
  disabled = false,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("common");

  const totalPages = Math.max(Math.ceil(totalItems / pageSize), 1);
  const from = totalItems === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, totalItems);

  const canGoPrev = !disabled && page > 1;
  const canGoNext = !disabled && page < totalPages;

  return (
    <PaginatorContainer>
      <Typography
        sx={{
          fontSize: "13px",
          color: theme.palette.text.primary,
          mr: 1,
        }}
      >
        {t("paginator-range", { from, to, total: totalItems })}
      </Typography>
      <NavBtn
        disabled={!canGoPrev}
        onClick={() => onPageChange(page - 1)}
        aria-label="previous page"
      >
        <ChevronLeft size={18} />
      </NavBtn>
      <NavBtn
        disabled={!canGoNext}
        onClick={() => onPageChange(page + 1)}
        aria-label="next page"
      >
        <ChevronRight size={18} />
      </NavBtn>
    </PaginatorContainer>
  );
};

export default PaginatorCst;
